// extracted by mini-css-extract-plugin
export default {"textInputWrapper":"_c2a8dd3a","headerInput":"_b40846b","animatedPlaceholderPadding":"_5138e60f","usePaddingLeft":"_b952cceb"};